export const ReferAFriendGraphic = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='375' height='138.281'>
			<defs>
				<path id='a' d='M10.401 0 0 7.601 15.6 19 26 11.4z' />
			</defs>
			<g fill='none' fillRule='evenodd' transform='translate(1)'>
				<path
					fill='#0CF'
					fillOpacity='.168'
					fillRule='nonzero'
					d='m188.576 75.281 23.162-26.106a17.991 17.991 0 0 0-.287-25.71c-7.285-7.021-18.968-6.894-26.095.283-4.712-4.542-11.526-6.261-17.875-4.511s-11.267 6.704-12.903 12.996c-1.636 6.292.259 12.966 4.972 17.508l25.769 25.54'
				/>
				<rect
					width='125'
					height='113'
					y='24.281'
					fill='#0CF'
					fillOpacity='.068'
					fillRule='nonzero'
					stroke='#06F'
					strokeWidth='2'
					rx='6'
				/>
				<rect
					width='125'
					height='113'
					x='248'
					y='10.281'
					fill='#99DB56'
					fillOpacity='.228'
					fillRule='nonzero'
					stroke='#99DB56'
					strokeWidth='2'
					rx='6'
				/>
				<path
					stroke='#0CF'
					strokeOpacity='.484'
					strokeWidth='2'
					d='M126 77.989s19.427-6.431 27.701 2.37C161.976 89.158 185 75.281 185 75.281'
				/>
				<path
					stroke='#0CF'
					strokeOpacity='.484'
					strokeWidth='2'
					d='M284 81.633s-3.596-8.693-28.045-.724c-24.45 7.969-58.967 7.607-67.596-4.709l23.018-26.527c7.082-7.294 6.954-18.99-.286-26.124-7.24-7.135-18.849-7.006-25.931.288-7.24-7.135-18.849-7.006-25.931.287-7.082 7.294-6.954 18.99.285 26.124L185.123 76.2'
				/>
				<circle cx='73' cy='71.281' r='12' fill='#2F2E41' fillRule='nonzero' />
				<path
					fill='#9F616A'
					fillRule='nonzero'
					d='M67.046 76.281s-3.86 8.51-4.963 8.784c-1.102.275 9.098 5.216 9.098 5.216s1.93-10.431 2.757-10.98c.827-.55-6.892-3.02-6.892-3.02Z'
				/>
				<circle cx='72' cy='75.281' r='8' fill='#9F616A' fillRule='nonzero' />
				<path
					fill='#06F'
					fillRule='nonzero'
					d='M79 137.281H45a530.082 530.082 0 0 1 3.593-13s25.642 5.816 26.19 6.109c.31.348.583.728.817 1.135.802 1.241 2.081 3.373 3.4 5.756Z'
				/>
				<path
					fill='#9F616A'
					fillRule='nonzero'
					d='m37 57.618-8.525-12.961s2.108-13.597-.734-11.06C24.9 36.131 24 46.372 24 46.372l9.874 14.909L37 57.618Zm75.539 23.584 7.274-.582s8.621-9.905 9.159-6.7c.539 3.204-7.004 10.196-7.004 10.196L112 85.281l.539-4.079Z'
				/>
				<path
					fill='#E072BE'
					fillRule='nonzero'
					d='M57 84.049v-2.833s-7.255-4.815-6.976-5.665c.279-.85-.558-1.416-.558-1.416s-.838-1.134-.838-1.417c0-.283-1.116-.566-1.116-.566l-6.976-8.215s-3.907-7.932-4.744-7.649c-.837.284-5.302 1.983-4.744 3.116.558 1.133 16.185 25.495 16.185 25.495s.837 5.382 2.233 5.382c1.394 0 7.534-6.232 7.534-6.232Zm20.126 3.782s6.19-.278 6.471 0c.282.277 4.221 0 4.221 0s10.693-2.502 11.537-3.336c.844-.834 14.913-4.447 15.476-2.78.563 1.668 1.97 5.004.563 5.56C113.987 87.83 76 97.281 76 97.281l1.126-9.45Z'
				/>
				<circle cx='68' cy='58.281' r='5' fill='#2F2E41' fillRule='nonzero' />
				<path
					fill='#2F2E41'
					fillRule='nonzero'
					d='M61.132 56.281c0-2.56 2.101-4.706 4.868-4.973a5.96 5.96 0 0 0-.566-.027c-1.941 0-3.735.953-4.706 2.5a4.656 4.656 0 0 0 0 5c.97 1.547 2.765 2.5 4.706 2.5.189 0 .378-.01.566-.027-2.767-.267-4.868-2.413-4.868-4.973Z'
				/>
				<ellipse cx='75' cy='67.281' fill='#2F2E41' fillRule='nonzero' rx='8' ry='5' />
				<path
					fill='#E072BE'
					fillRule='nonzero'
					d='M64.71 81.557s-2.549 1.93-3.115 2.206c-.566.275-3.964-2.482-4.53-2.482-.567 0-7.929 8.272-7.929 8.272s1.368 1.534 0 9.374c-.513 2.94-1.531 15.511-1.531 17.165s-5.548 5.72-.451 9.304c5.097 3.584 29.448 7.444 29.731 5.239.283-2.206-2.831-7.996-1.416-10.753 1.416-2.758 1.416-12.959 1.416-12.959l1.7-10.753L80 87.623s-6.654-1.793-7.22-1.793c-.567 0-3.115 3.86-8.07-4.273Z'
				/>
				<path fill='#6C63FF' fillRule='nonzero' d='m309.875 54.562 5.701-.22.284 7.328-5.7.221-.285-7.329z' />
				<path
					fill='#E1A98A'
					fillRule='nonzero'
					d='M289.81 80.196s-7.935-3.926-7.808-.536c.126 3.391 7.998 5.621 7.998 5.621l-.19-5.085Z'
				/>
				<path
					fill='#00528C'
					fillRule='nonzero'
					d='M325.629 123.281H289c.764-3.683 2.219-8.126 3.357-11.328.902-2.533 1.599-4.292 1.599-4.292 4.16-4.819 10.197-4.942 15.861-3.752.753.157 1.502.337 2.244.54 1.324.35 2.61.756 3.825 1.161 2.096.702 3.988 1.411 5.516 1.892.769.261 1.559.452 2.36.568.176.019.352.027.529.022.606-.025 1.025.644 1.296 1.813.613 2.637.472 7.833.042 13.376Z'
				/>
				<path
					fill='#E1A98A'
					fillRule='nonzero'
					d='M319.243 48.281s4.585 6.536 6.373 8.05c1.787 1.512-3.242 4.843-3.242 4.843l-9.001 1.107s.114-7.491-.35-8.263c-.464-.771 6.22-5.737 6.22-5.737Z'
				/>
				<path
					fill='#D7EBF7'
					fillRule='nonzero'
					d='M312.181 56.134s1.78 3.177 3.431 3.115c1.652-.063 10.194-3.633 10.559-4.864.364-1.23 2.829 8.816 2.829 8.816l-20.902 36.08L303 95.825l2.47-21.184 2.029-11.434 4.682-7.073Z'
				/>
				<path
					fill='#046CB6'
					fillRule='nonzero'
					d='M325.618 88.653a11.267 11.267 0 0 0-1.252 5.291c.003.08.006.161.013.241.194 3.727 1.568 8.037 2.061 11.171.357 2.249.255 3.89-1.061 4.276-3.193.93.465 1.595-11.887 5.703-12.353 4.108-14.508.562-14.54-.244-.031-.805 1.75-6.923 1.331-7.31-.419-.387-5.857 5.066-7.501 4.323-1.643-.742-.187-4.831-.187-4.831s3.702-8.612 3.624-10.626c-.079-2.013 5.607-11.508 5.607-11.508l3.867-25.152s1.487-3.284 3.486-3.764a4.958 4.958 0 0 1 3.659.664l-3.346 7.389-3.53 13.04.591 4.817s4.104-8.628 6.8-11.958c2.696-3.33 8.444-11.215 8.444-11.215s1.342-4.525.329-5.877c-1.013-1.355 4.226-1.559 6.46 4 1.184 2.947 3.106 7.34 4.31 11.431 1.073 3.624 1.58 7.012.517 8.949-1.625 2.958-5.712 6.847-7.795 11.19Z'
				/>
				<path
					fill='#000'
					fillRule='nonzero'
					d='M334.413 78.165c-1.624 2.939-5.709 6.801-7.791 11.116-.544-1.946-1.208-3.96-1.208-3.96s-2.545-13.522 4.983-17.017a5.067 5.067 0 0 1 3.5.971c1.072 3.6 1.579 6.966.516 8.89Z'
					opacity='.1'
				/>
				<path
					fill='#046CB6'
					fillRule='nonzero'
					d='m304.368 76.281-6.466 2.039-8.978.376-.924 8.436 14.755 1.149s3.685-11.203 1.613-12Z'
				/>
				<path
					fill='#E1A98A'
					fillRule='nonzero'
					d='M315.018 103.281s-8.711 1.39-6.723 3.912c1.988 2.522 9.705-.13 9.705-.13l-2.982-3.782Z'
				/>
				<path
					fill='#000'
					fillRule='nonzero'
					d='M324.887 95.281c.198 3.653 1.607 7.879 2.113 10.951-2.791 2.523-5.445 4.748-6.445 4.785-2.067.077-5.389-.195-6.613.245-1.224.441-1.942-7.044-1.942-7.044s.73-2.399 3.989-3.705c2.199-.884 6.415-3.282 8.898-5.232Z'
					opacity='.1'
				/>
				<path
					fill='#046CB6'
					fillRule='nonzero'
					d='M329.547 64.308s6.806-1.07 6.439 10.236c-.368 11.306.717 18.523-2.02 20.646-2.738 2.123-11.63 11.744-13.641 11.822-2.011.078-5.244-.2-6.435.25-1.191.449-1.89-7.186-1.89-7.186s.711-2.447 3.882-3.78c3.171-1.333 10.641-6.06 10.579-7.67-.063-1.611-1.89-7.186-1.89-7.186s-2.541-13.614 4.976-17.132Z'
				/>
				<circle cx='312.5' cy='48.781' r='8.5' fill='#E1A98A' fillRule='nonzero' />
				<path
					fill='#796549'
					fillRule='nonzero'
					d='M307.761 36.026c-.216.18-.474.305-.752.364a.536.536 0 0 1-.622-.416 2.17 2.17 0 0 1-.853 1.057c-.418.21-1.064.034-1.124-.417-.062.345-.22.665-.454.925a.697.697 0 0 1-.956.031c.183.966.07 1.96.128 2.94.057.98.328 2.02 1.094 2.664 1.119.94 2.8.708 4.271.53.223-.045.454-.033.67.035.551.227.526.968.533 1.546.093 2.095 1.739 3.819 3.893 4.078a2.287 2.287 0 0 0 1.656-.39c.418-.343.631-.9 1.11-1.157.778-.418 1.723.192 2.292.853.569.662 1.13 1.476 2.012 1.597 1.166.16 2.054-.988 2.49-2.045a11.55 11.55 0 0 0-.245-9.262c-2.435-5.127-10.753-5.937-15.143-2.933Z'
				/>
				<path
					fill='#06F'
					fillRule='nonzero'
					d='m103.066 75.281 4.064-4.58a3.157 3.157 0 0 0-.051-4.51 3.272 3.272 0 0 0-4.578.05 3.27 3.27 0 0 0-3.136-.792 3.212 3.212 0 0 0-2.264 2.28 3.158 3.158 0 0 0 .873 3.071l4.521 4.481'
				/>
				<path
					fill='#06F'
					fillRule='nonzero'
					d='m53.492 49.281 5.69-6.412a4.419 4.419 0 0 0-.071-6.315 4.58 4.58 0 0 0-6.41.07 4.58 4.58 0 0 0-4.39-1.108 4.497 4.497 0 0 0-3.17 3.192 4.422 4.422 0 0 0 1.222 4.3l6.33 6.273'
					opacity='.46'
				/>
				<path
					fill='#06F'
					fillRule='nonzero'
					d='m100.816 39.281 8.127-9.16a6.312 6.312 0 0 0-.101-9.021c-2.556-2.464-6.655-2.42-9.156.1a6.541 6.541 0 0 0-6.272-1.584c-2.227.614-3.953 2.353-4.527 4.56a6.317 6.317 0 0 0 1.744 6.144l9.042 8.961'
				/>
				<path
					fill='#06F'
					fillRule='nonzero'
					d='m25.14 117.281 10.565-11.908a8.206 8.206 0 0 0-.131-11.727c-3.323-3.203-8.652-3.145-11.903.129a8.505 8.505 0 0 0-8.153-2.058c-2.896.798-5.14 3.058-5.886 5.928a8.211 8.211 0 0 0 2.268 7.986l11.754 11.65'
					opacity='.167'
				/>
				<g transform='translate(172 39.281)'>
					<mask id='b' fill='#fff'>
						<use xlinkHref='#a' />
					</mask>
					<g mask='url(#b)'>
						<path fill='#06F' fillRule='nonzero' d='M10.401 0 0 7.601 15.6 19 26 11.4z' />
						<g fillRule='nonzero'>
							<path
								fill='#06F'
								d='M15.6 17.572a5.907 5.907 0 0 1-3.502-1.147L-3.504 5.023A6.235 6.235 0 0 1-6.03 0c0-1.987.943-3.863 2.521-5.019l10.405-7.604A5.902 5.902 0 0 1 10.4-13.77c1.263 0 2.473.396 3.502 1.146L29.504-1.222A6.232 6.232 0 0 1 32.03 3.8c0 1.987-.943 3.863-2.521 5.019l-10.405 7.603a5.902 5.902 0 0 1-3.504 1.149Z'
							/>
							<path
								fill='#0065FD'
								d='M15.6 17.478a5.814 5.814 0 0 1-3.448-1.13l-15.603-11.4A6.139 6.139 0 0 1-5.938 0c0-1.956.928-3.805 2.483-4.943l10.404-7.604a5.818 5.818 0 0 1 3.45-1.131c1.244 0 2.436.39 3.45 1.129L29.45-1.146a6.137 6.137 0 0 1 2.487 4.947c0 1.957-.928 3.805-2.483 4.943l-10.404 7.604a5.818 5.818 0 0 1-3.45 1.131Z'
							/>
							<path
								fill='#0065FB'
								d='M15.6 17.384a5.724 5.724 0 0 1-3.395-1.112L-3.397 4.871A6.045 6.045 0 0 1-5.847 0c0-1.927.915-3.745 2.445-4.867l10.405-7.602a5.725 5.725 0 0 1 3.397-1.115c1.225 0 2.398.385 3.395 1.113L29.397-1.07a6.042 6.042 0 0 1 2.45 4.87c0 1.929-.915 3.746-2.445 4.868l-10.405 7.603a5.725 5.725 0 0 1-3.397 1.114v-.002Z'
							/>
							<path
								fill='#0064F9'
								d='M15.6 17.29a5.63 5.63 0 0 1-3.342-1.094L-3.344 4.794A5.95 5.95 0 0 1-5.755 0c0-1.897.9-3.687 2.406-4.79l10.405-7.604A5.63 5.63 0 0 1 10.4-13.49c1.206 0 2.36.378 3.342 1.094L29.344-.993A5.95 5.95 0 0 1 31.755 3.8c0 1.897-.9 3.687-2.406 4.79l-10.405 7.604A5.63 5.63 0 0 1 15.6 17.29Z'
							/>
							<path
								fill='#0063F7'
								d='M15.6 17.197a5.544 5.544 0 0 1-3.289-1.077L-3.29 4.718A5.853 5.853 0 0 1-5.663.001c0-1.866.884-3.628 2.367-4.714L7.11-12.317a5.551 5.551 0 0 1 3.292-1.08c1.187 0 2.323.372 3.289 1.077L29.292-.92A5.853 5.853 0 0 1 31.664 3.8c0 1.866-.884 3.628-2.367 4.714l-10.405 7.604a5.547 5.547 0 0 1-3.29 1.079H15.6Z'
							/>
							<path
								fill='#0063F6'
								d='M15.6 17.103a5.455 5.455 0 0 1-3.236-1.06L-3.238 4.642A5.76 5.76 0 0 1-5.572 0c0-1.835.871-3.57 2.33-4.638L7.162-12.24a5.454 5.454 0 0 1 3.238-1.062c1.167 0 2.286.366 3.236 1.06L29.239-.841a5.758 5.758 0 0 1 2.334 4.64c0 1.837-.871 3.57-2.33 4.639L18.84 16.04a5.454 5.454 0 0 1-3.238 1.062Z'
							/>
							<path
								fill='#0062F4'
								d='M15.6 17.01a5.362 5.362 0 0 1-3.182-1.043L-3.184 4.565A5.664 5.664 0 0 1-5.48 0c0-1.806.856-3.511 2.292-4.562l10.404-7.603a5.362 5.362 0 0 1 3.185-1.044c1.148 0 2.247.36 3.182 1.043L29.185-.764A5.664 5.664 0 0 1 31.481 3.8a5.66 5.66 0 0 1-2.292 4.562l-10.404 7.604A5.365 5.365 0 0 1 15.6 17.01Z'
							/>
							<path
								fill='#0061F2'
								d='M15.6 16.916a5.278 5.278 0 0 1-3.13-1.025L-3.13 4.489A5.57 5.57 0 0 1-5.39 0c0-1.776.843-3.452 2.254-4.486L7.27-12.088a5.279 5.279 0 0 1 3.13-1.027c1.13 0 2.21.354 3.13 1.025L29.132-.69A5.57 5.57 0 0 1 31.39 3.8a5.568 5.568 0 0 1-2.254 4.485L18.731 15.89a5.279 5.279 0 0 1-3.13 1.027Z'
							/>
							<path
								fill='#0061F0'
								d='M15.6 16.822a5.185 5.185 0 0 1-3.076-1.008L-3.078 4.413A5.475 5.475 0 0 1-5.297 0c0-1.745.828-3.393 2.215-4.409l10.405-7.604A5.188 5.188 0 0 1 10.4-13.02c1.11 0 2.172.348 3.076 1.007L29.079-.612A5.475 5.475 0 0 1 31.298 3.8a5.471 5.471 0 0 1-2.215 4.409L18.678 15.81a5.188 5.188 0 0 1-3.078 1.01Z'
							/>
							<path
								fill='#0060EE'
								d='M15.6 16.728a5.094 5.094 0 0 1-3.023-.99L-3.025 4.336A5.383 5.383 0 0 1-5.205 0 5.38 5.38 0 0 1-3.03-4.333l10.405-7.603a5.094 5.094 0 0 1 3.025-.991c1.09 0 2.135.342 3.023.99L29.026-.535a5.38 5.38 0 0 1 2.18 4.336 5.378 5.378 0 0 1-2.176 4.333l-10.404 7.603a5.095 5.095 0 0 1-3.025.992v-.001Z'
							/>
							<path
								fill='#0060EC'
								d='M15.6 16.634a5.008 5.008 0 0 1-2.97-.973L-2.97 4.26A5.285 5.285 0 0 1-5.114 0c0-1.685.8-3.276 2.138-4.257L7.43-11.859a5.01 5.01 0 0 1 2.972-.974c1.07 0 2.097.336 2.97.972L28.972-.46a5.287 5.287 0 0 1 2.142 4.26c0 1.685-.8 3.276-2.138 4.256L18.573 15.66a5.01 5.01 0 0 1-2.972.974v.001Z'
							/>
							<path
								fill='#005FEA'
								d='M15.6 16.54c-1.051 0-2.06-.33-2.916-.955L-2.917 4.184A5.19 5.19 0 0 1-5.021.001c0-1.655.785-3.218 2.1-4.18l10.403-7.604a4.917 4.917 0 0 1 2.919-.957c1.052 0 2.06.331 2.916.955L28.92-.383A5.19 5.19 0 0 1 31.023 3.8a5.188 5.188 0 0 1-2.1 4.18L18.52 15.582a4.917 4.917 0 0 1-2.919.957v.001Z'
							/>
							<path
								fill='#005EE8'
								d='M15.6 16.447a4.832 4.832 0 0 1-2.863-.938L-2.864 4.107A5.097 5.097 0 0 1-4.93 0c0-1.625.77-3.158 2.06-4.104l10.405-7.603a4.824 4.824 0 0 1 2.865-.94 4.83 4.83 0 0 1 2.863.938L28.866-.308A5.094 5.094 0 0 1 30.931 3.8c0 1.625-.77 3.158-2.06 4.104l-10.405 7.603a4.827 4.827 0 0 1-2.865.94Z'
							/>
							<path
								fill='#005EE6'
								d='M15.6 16.353a4.742 4.742 0 0 1-2.81-.92L-2.81 4.03A5.001 5.001 0 0 1-4.838 0c0-1.594.757-3.1 2.023-4.028L7.589-11.63a4.74 4.74 0 0 1 2.812-.922 4.74 4.74 0 0 1 2.81.92L28.813-.23A5.001 5.001 0 0 1 30.84 3.8a5 5 0 0 1-2.023 4.029L18.413 15.43a4.74 4.74 0 0 1-2.812.922Z'
							/>
							<path
								fill='#005DE5'
								d='M15.6 16.26a4.655 4.655 0 0 1-2.757-.903L-2.759 3.955A4.907 4.907 0 0 1-4.747.001c0-1.564.742-3.041 1.985-3.951l10.404-7.604a4.647 4.647 0 0 1 2.759-.904c.995 0 1.947.312 2.757.902L28.76-.154A4.905 4.905 0 0 1 30.748 3.8a4.902 4.902 0 0 1-1.985 3.95l-10.404 7.603a4.649 4.649 0 0 1-2.759.905v.001Z'
							/>
							<path
								fill='#005CE3'
								d='M15.6 16.165c-.974 0-1.91-.306-2.703-.885L-2.706 3.878A4.811 4.811 0 0 1-4.656.001c0-1.534.729-2.983 1.947-3.875l10.404-7.603a4.558 4.558 0 0 1 2.706-.887c.975 0 1.91.306 2.703.885L28.707-.078a4.812 4.812 0 0 1 1.95 3.878 4.811 4.811 0 0 1-1.947 3.875l-10.404 7.603c-.795.58-1.73.887-2.706.887Z'
							/>
							<path
								fill='#005CE1'
								d='M15.6 16.071c-.956 0-1.872-.3-2.65-.868L-2.652 3.802A4.719 4.719 0 0 1-4.564 0c0-1.504.713-2.923 1.909-3.799L7.748-11.4a4.471 4.471 0 0 1 2.653-.87c.957 0 1.872.3 2.65.869L28.653-.001a4.716 4.716 0 0 1 1.912 3.802A4.714 4.714 0 0 1 28.656 7.6l-10.403 7.602c-.78.569-1.696.87-2.653.87Z'
							/>
							<path
								fill='#005BDF'
								d='M15.6 15.978a4.38 4.38 0 0 1-2.597-.851L-2.599 3.725A4.624 4.624 0 0 1-4.473 0c0-1.473.698-2.865 1.87-3.722l10.405-7.603a4.38 4.38 0 0 1 2.599-.852c.937 0 1.834.295 2.597.851L28.6.076A4.621 4.621 0 0 1 30.474 3.8a4.617 4.617 0 0 1-1.87 3.722L18.2 15.126a4.38 4.38 0 0 1-2.599.852Z'
							/>
							<path
								fill='#005ADD'
								d='M15.6 15.884a4.293 4.293 0 0 1-2.544-.833L-2.546 3.65A4.527 4.527 0 0 1-4.382 0c0-1.443.685-2.806 1.832-3.647l10.405-7.602a4.293 4.293 0 0 1 5.09-.002L28.545.15A4.53 4.53 0 0 1 30.382 3.8a4.527 4.527 0 0 1-1.832 3.646L18.146 15.05a4.287 4.287 0 0 1-2.545.835Z'
							/>
							<path
								fill='#005ADB'
								d='M15.6 15.79a4.205 4.205 0 0 1-2.49-.816L-2.494 3.573A4.434 4.434 0 0 1-4.29 0c0-1.414.67-2.748 1.793-3.57l10.405-7.602a4.205 4.205 0 0 1 4.983-.001L28.493.226a4.433 4.433 0 0 1 1.797 3.574c0 1.414-.67 2.748-1.793 3.57l-10.404 7.602a4.202 4.202 0 0 1-2.492.817Z'
							/>
							<path
								fill='#0059D9'
								d='M15.6 15.696a4.112 4.112 0 0 1-2.437-.798L-2.44 3.496A4.338 4.338 0 0 1-4.198 0c0-1.383.656-2.69 1.754-3.494l10.405-7.602a4.11 4.11 0 0 1 2.439-.8c.879 0 1.721.277 2.437.8L28.44.303a4.34 4.34 0 0 1 1.758 3.497c0 1.383-.656 2.69-1.754 3.494L18.04 14.898a4.11 4.11 0 0 1-2.439.8v-.002Z'
							/>
							<path
								fill='#0058D7'
								d='M15.6 15.603c-.859 0-1.684-.27-2.384-.781L-2.386 3.421A4.245 4.245 0 0 1-4.106 0c0-1.352.64-2.63 1.716-3.418l10.404-7.602a4.025 4.025 0 0 1 4.77-.002L28.386.38a4.243 4.243 0 0 1 1.72 3.42c0 1.353-.64 2.63-1.716 3.417L17.987 14.82c-.701.512-1.527.783-2.386.783Z'
							/>
							<path
								fill='#0058D5'
								d='M15.6 15.509c-.84 0-1.646-.264-2.331-.764L-2.333 3.344A4.15 4.15 0 0 1-4.015 0c0-1.323.628-2.572 1.678-3.341l10.405-7.603a3.934 3.934 0 0 1 4.663-.001L28.333.457A4.151 4.151 0 0 1 30.015 3.8a4.147 4.147 0 0 1-1.678 3.34l-10.403 7.603c-.685.5-1.491.765-2.332.765H15.6Z'
							/>
							<path
								fill='#0057D3'
								d='M15.6 15.415c-.82 0-1.609-.258-2.278-.746L-2.28 3.267A4.056 4.056 0 0 1-3.923 0c0-1.293.612-2.513 1.64-3.265l10.404-7.602a3.84 3.84 0 0 1 2.279-.747c.822 0 1.609.258 2.278.746L28.28.533a4.054 4.054 0 0 1 1.643 3.268 4.052 4.052 0 0 1-1.64 3.265L17.88 14.67a3.84 3.84 0 0 1-2.279.747v-.001Z'
							/>
							<path
								fill='#0056D2'
								d='M15.6 15.321a3.75 3.75 0 0 1-2.225-.729L-2.227 3.191A3.961 3.961 0 0 1-3.832 0c0-1.262.6-2.455 1.602-3.189L8.174-10.79a3.75 3.75 0 0 1 2.226-.73 3.75 3.75 0 0 1 2.225.729L28.225.61a3.958 3.958 0 0 1 1.606 3.19c0 1.263-.6 2.455-1.602 3.19l-10.403 7.602a3.75 3.75 0 0 1-2.226.73Z'
							/>
							<path
								fill='#0056D0'
								d='M15.6 15.227a3.668 3.668 0 0 1-2.171-.71L-2.174 3.114A3.865 3.865 0 0 1-3.74 0c0-1.232.584-2.395 1.563-3.112l10.404-7.602a3.666 3.666 0 0 1 4.344-.001L28.173.687a3.865 3.865 0 0 1 1.566 3.115 3.86 3.86 0 0 1-1.563 3.112l-10.403 7.602a3.664 3.664 0 0 1-2.173.713v-.002Z'
							/>
							<path
								fill='#0055CE'
								d='M15.6 15.134c-.763 0-1.495-.24-2.118-.694L-2.12 3.038A3.772 3.772 0 0 1-3.648 0a3.77 3.77 0 0 1 1.526-3.036L8.28-10.638a3.575 3.575 0 0 1 4.238-.001L28.12.762a3.77 3.77 0 0 1 1.529 3.039 3.77 3.77 0 0 1-1.526 3.036L17.72 14.44a3.572 3.572 0 0 1-2.12.695Z'
							/>
							<path
								fill='#05C'
								d='M15.6 15.04a3.485 3.485 0 0 1-2.065-.677L-2.066 2.962A3.674 3.674 0 0 1-3.556 0c0-1.172.556-2.278 1.487-2.96L8.335-10.56a3.48 3.48 0 0 1 2.066-.678c.745 0 1.458.234 2.065.677L28.067.839a3.676 3.676 0 0 1 1.49 2.962 3.673 3.673 0 0 1-1.487 2.96l-10.403 7.601a3.48 3.48 0 0 1-2.066.678Z'
							/>
							<path
								fill='#0054CA'
								d='M15.6 14.946c-.725 0-1.42-.228-2.012-.658L-2.013 2.886A3.583 3.583 0 0 1-3.464.001c0-1.14.542-2.22 1.448-2.883l10.404-7.603a3.396 3.396 0 0 1 4.025-.002L28.013.915A3.58 3.58 0 0 1 29.466 3.8c0 1.141-.542 2.22-1.448 2.883l-10.403 7.602a3.396 3.396 0 0 1-2.013.66v.001Z'
							/>
							<path
								fill='#0053C8'
								d='M15.6 14.852a3.305 3.305 0 0 1-1.959-.641L-1.959 2.81A3.486 3.486 0 0 1-3.374 0c0-1.111.527-2.161 1.41-2.807L8.441-10.41a3.302 3.302 0 0 1 1.96-.642c.706 0 1.383.221 1.959.64L27.96.992a3.485 3.485 0 0 1 1.414 2.81 3.484 3.484 0 0 1-1.41 2.807L17.56 14.21a3.302 3.302 0 0 1-1.96.642Z'
							/>
							<path
								fill='#0053C6'
								d='M15.6 14.759a3.214 3.214 0 0 1-1.905-.625L-1.907 2.733A3.393 3.393 0 0 1-3.28 0 3.39 3.39 0 0 1-1.91-2.73l10.404-7.602a3.211 3.211 0 0 1 1.907-.626c.688 0 1.346.216 1.905.625l15.602 11.4a3.392 3.392 0 0 1 1.374 2.734 3.39 3.39 0 0 1-1.372 2.73l-10.402 7.602c-.56.41-1.22.626-1.907.626Z'
							/>
							<path
								fill='#0052C4'
								d='M15.6 14.665c-.668 0-1.308-.21-1.851-.607L-1.852 2.656A3.296 3.296 0 0 1-3.188 0c0-1.05.498-2.043 1.333-2.655l10.402-7.6a3.127 3.127 0 0 1 3.705-.002L27.853 1.145A3.296 3.296 0 0 1 29.19 3.8c0 1.05-.498 2.043-1.333 2.655l-10.402 7.602a3.127 3.127 0 0 1-1.854.608v-.001Z'
							/>
							<path
								fill='#0051C2'
								d='M15.6 14.57c-.648 0-1.27-.203-1.798-.588L-1.799 2.581A3.202 3.202 0 0 1-3.097 0 3.2 3.2 0 0 1-1.8-2.579L8.6-10.18c.529-.386 1.15-.59 1.8-.59.65 0 1.27.204 1.798.589L27.8 1.22a3.202 3.202 0 0 1 1.298 2.58 3.198 3.198 0 0 1-1.296 2.58L17.4 13.98c-.529.386-1.15.59-1.8.59h.001Z'
							/>
							<path
								fill='#0051C1'
								d='M15.6 14.477a2.94 2.94 0 0 1-1.745-.572l-15.6-11.401A3.108 3.108 0 0 1-3.006 0c0-.99.47-1.926 1.257-2.502l10.403-7.602a2.943 2.943 0 0 1 1.747-.572c.63 0 1.232.197 1.745.571l15.6 11.402a3.106 3.106 0 0 1 1.26 2.504c0 .991-.47 1.926-1.257 2.502l-10.403 7.601a2.943 2.943 0 0 1-1.747.573Z'
							/>
							<path
								fill='#0050BF'
								d='M15.6 14.383a2.85 2.85 0 0 1-1.692-.554l-15.6-11.402A3.012 3.012 0 0 1-2.915 0c0-.96.456-1.867 1.22-2.426l10.402-7.602a2.857 2.857 0 0 1 3.386 0l15.6 11.4A3.01 3.01 0 0 1 28.916 3.8c0 .96-.455 1.866-1.218 2.426l-10.403 7.602a2.857 2.857 0 0 1-1.694.555Z'
							/>
							<path
								fill='#004FBD'
								d='M15.6 14.29a2.763 2.763 0 0 1-1.638-.537L-1.64 2.353A2.918 2.918 0 0 1-2.822 0c0-.93.442-1.808 1.18-2.35L8.761-9.95a2.765 2.765 0 0 1 1.64-.538c.592 0 1.158.186 1.64.537L27.64 1.45a2.918 2.918 0 0 1 1.183 2.352c0 .93-.442 1.808-1.18 2.35l-10.402 7.601a2.765 2.765 0 0 1-1.64.538l-.002-.001Z'
							/>
							<path
								fill='#004FBB'
								d='M15.6 14.196c-.571 0-1.12-.18-1.585-.52l-15.601-11.4A2.824 2.824 0 0 1-2.73.001c0-.9.426-1.75 1.142-2.273L8.813-9.874a2.672 2.672 0 0 1 1.588-.52c.572 0 1.12.18 1.585.52l15.601 11.4a2.82 2.82 0 0 1 1.144 2.276c0 .9-.426 1.75-1.142 2.273l-10.401 7.601c-.467.341-1.015.52-1.588.52Z'
							/>
							<path
								fill='#004EB9'
								d='M15.6 14.102a2.58 2.58 0 0 1-1.532-.502L-1.533 2.2A2.727 2.727 0 0 1-2.64 0c0-.87.413-1.691 1.104-2.197L8.867-9.798a2.588 2.588 0 0 1 3.066-.001l15.601 11.4A2.728 2.728 0 0 1 28.64 3.8c0 .87-.413 1.691-1.104 2.197L17.134 13.6c-.45.329-.981.503-1.534.503Z'
							/>
							<path
								fill='#004DB7'
								d='M15.6 14.008a2.49 2.49 0 0 1-1.479-.485l-15.6-11.4A2.634 2.634 0 0 1-2.548 0c0-.84.398-1.633 1.065-2.12L8.92-9.723a2.496 2.496 0 0 1 2.96 0l15.6 11.4a2.633 2.633 0 0 1 1.068 2.123c0 .84-.398 1.632-1.065 2.12L17.08 13.524a2.496 2.496 0 0 1-1.48.485Z'
							/>
							<path
								fill='#004DB5'
								d='M15.6 13.914a2.404 2.404 0 0 1-1.426-.466l-15.6-11.4A2.537 2.537 0 0 1-2.457 0c0-.81.385-1.573 1.027-2.044L8.973-9.645a2.406 2.406 0 0 1 2.854 0l15.6 11.4a2.54 2.54 0 0 1 1.03 2.046c0 .81-.385 1.573-1.027 2.044l-10.402 7.602c-.42.306-.913.467-1.428.467Z'
							/>
							<path
								fill='#004CB3'
								d='M15.6 13.82c-.494 0-.97-.155-1.372-.45L-1.374 1.97a2.444 2.444 0 0 1-.99-1.969c0-.78.37-1.515.989-1.968L9.026-9.57a2.32 2.32 0 0 1 2.747-.001l15.601 11.4c.621.454.99 1.19.99 1.97s-.369 1.514-.988 1.968L16.975 13.37a2.32 2.32 0 0 1-1.375.45Z'
							/>
							<path
								fill='#004CB1'
								d='M15.6 13.727a2.22 2.22 0 0 1-1.32-.433l-15.6-11.4A2.348 2.348 0 0 1-2.272 0c0-.748.356-1.456.95-1.892L9.08-9.492a2.225 2.225 0 0 1 2.64 0l15.601 11.4c.597.437.952 1.144.952 1.893 0 .75-.356 1.456-.95 1.892L16.92 13.294a2.225 2.225 0 0 1-1.32.433Z'
							/>
							<path
								fill='#004BB0'
								d='M15.6 13.633c-.456 0-.894-.143-1.266-.414l-15.601-11.4A2.256 2.256 0 0 1-2.18 0c0-.719.34-1.398.912-1.815L9.134-9.416a2.134 2.134 0 0 1 2.533 0l15.601 11.4c.573.42.913 1.098.913 1.817a2.25 2.25 0 0 1-.912 1.815l-10.402 7.602c-.372.272-.81.415-1.267.415Z'
							/>
							<path
								fill='#004AAE'
								d='M15.6 13.54c-.437 0-.857-.138-1.213-.398l-15.6-11.4A2.16 2.16 0 0 1-2.09 0c0-.689.327-1.34.874-1.74L9.187-9.34a2.048 2.048 0 0 1 2.427-.001l15.6 11.4c.55.402.876 1.052.876 1.74a2.16 2.16 0 0 1-.874 1.74l-10.402 7.602c-.357.26-.776.398-1.214.398Z'
							/>
							<path
								fill='#004AAC'
								d='M15.6 13.446c-.418 0-.82-.132-1.16-.38L-1.16 1.664A2.063 2.063 0 0 1-1.998 0c0-.659.312-1.28.835-1.663L9.24-9.264a1.957 1.957 0 0 1 2.32 0l15.602 11.4c.524.385.836 1.006.836 1.665 0 .658-.312 1.28-.835 1.663L16.76 13.065c-.341.25-.743.382-1.16.382v-.001Z'
							/>
							<path
								fill='#0049AA'
								d='M15.6 13.352a1.86 1.86 0 0 1-1.106-.363l-15.601-11.4c-.501-.368-.8-.96-.8-1.589 0-.628.298-1.221.798-1.587L9.292-9.19a1.864 1.864 0 0 1 2.214 0l15.601 11.4c.501.367.8.96.8 1.589 0 .63-.298 1.221-.798 1.587l-10.401 7.6a1.864 1.864 0 0 1-1.108.364Z'
							/>
							<path
								fill='#0048A8'
								d='M15.6 13.258c-.38 0-.744-.119-1.053-.345l-15.601-11.4A1.875 1.875 0 0 1-1.814 0c0-.598.283-1.163.758-1.51L9.346-9.11a1.782 1.782 0 0 1 2.107-.001l15.601 11.4c.477.35.76.914.76 1.512s-.283 1.163-.758 1.51l-10.402 7.601c-.31.227-.674.346-1.054.346Z'
							/>
							<path
								fill='#0048A6'
								d='M15.6 13.164c-.36 0-.706-.113-1-.328L-1 1.436A1.782 1.782 0 0 1-1.723.001c0-.568.269-1.104.72-1.434l10.402-7.6a1.69 1.69 0 0 1 2-.002l15.602 11.4c.452.332.722.868.722 1.436s-.269 1.104-.72 1.434l-10.402 7.6a1.69 1.69 0 0 1-1 .33Z'
							/>
							<path
								fill='#0047A4'
								d='M15.6 13.07c-.34 0-.669-.107-.947-.31l-15.6-11.4A1.686 1.686 0 0 1-1.633 0c0-.539.256-1.045.682-1.358L9.452-8.96a1.598 1.598 0 0 1 1.895 0l15.6 11.4c.428.314.684.821.684 1.36 0 .538-.256 1.045-.682 1.358l-10.4 7.6c-.28.204-.608.311-.949.311Z'
							/>
							<path
								fill='#0046A2'
								d='M15.6 12.977c-.322 0-.631-.101-.893-.293L-.895 1.284A1.594 1.594 0 0 1-1.54 0c0-.507.24-.986.643-1.282l10.401-7.6a1.505 1.505 0 0 1 1.788-.001l15.6 11.4c.405.296.646.776.646 1.283 0 .507-.24.986-.643 1.282l-10.401 7.6a1.505 1.505 0 0 1-.895.294h.001Z'
							/>
							<path
								fill='#0046A0'
								d='M15.6 12.883c-.302 0-.594-.095-.84-.275l-15.6-11.4A1.497 1.497 0 0 1-1.447 0c0-.477.226-.928.606-1.205l10.4-7.6a1.419 1.419 0 0 1 1.682-.002l15.6 11.4c.38.279.607.73.607 1.207 0 .477-.226.928-.606 1.205l-10.4 7.6c-.248.181-.538.277-.842.277Z'
							/>
							<path
								fill='#00459E'
								d='M15.6 12.789c-.284 0-.556-.089-.787-.258l-15.6-11.4A1.401 1.401 0 0 1-1.356 0c0-.447.212-.87.568-1.13l10.4-7.6a1.327 1.327 0 0 1 1.576 0l15.6 11.4c.356.26.569.683.569 1.13 0 .447-.212.87-.568 1.13l-10.4 7.6c-.232.17-.505.258-.789.258Z'
							/>
							<path
								fill='#00449D'
								d='M15.6 12.695c-.264 0-.518-.082-.734-.24L-.734 1.053A1.307 1.307 0 0 1-1.264 0c0-.417.198-.81.529-1.053l10.4-7.6a1.234 1.234 0 0 1 1.47 0l15.6 11.4c.332.243.53.636.53 1.054 0 .417-.198.81-.529 1.053l-10.4 7.6c-.217.159-.47.241-.736.241Z'
							/>
							<path
								fill='#00449B'
								d='M15.6 12.601c-.245 0-.48-.076-.68-.222L-.68.979A1.213 1.213 0 0 1-1.174 0c0-.386.184-.751.491-.976l10.401-7.6a1.15 1.15 0 0 1 1.363-.002l15.6 11.4c.308.227.491.592.491.978s-.183.751-.49.976l-10.401 7.6a1.15 1.15 0 0 1-.682.224Z'
							/>
							<path
								fill='#004399'
								d='M15.6 12.508c-.226 0-.443-.07-.627-.206L-.627.902A1.12 1.12 0 0 1-.629-.9L9.771-8.5a1.059 1.059 0 0 1 1.256 0l15.6 11.4a1.12 1.12 0 0 1 .001 1.801l-10.4 7.6a1.059 1.059 0 0 1-.629.207Z'
							/>
							<path
								fill='#004297'
								d='M15.6 12.414a.963.963 0 0 1-.574-.189L-.574.825A1.023 1.023 0 0 1-.99 0c0-.327.154-.634.414-.824l10.4-7.6a.968.968 0 0 1 1.15 0l15.6 11.4c.26.19.415.498.415.825 0 .327-.154.634-.414.824l-10.4 7.6a.968.968 0 0 1-.576.189Z'
							/>
							<path
								fill='#004295'
								d='M15.6 12.32a.876.876 0 0 1-.521-.17L-.521.75A.93.93 0 0 1-.522-.748l10.4-7.6a.882.882 0 0 1 1.044-.002l15.6 11.4a.93.93 0 0 1 .001 1.497l-10.4 7.6a.882.882 0 0 1-.523.172Z'
							/>
							<path
								fill='#004193'
								d='M15.6 12.226a.785.785 0 0 1-.468-.153L-.468.673A.834.834 0 0 1-.469-.671l10.4-7.6a.79.79 0 0 1 .938 0l15.6 11.4a.834.834 0 0 1 .001 1.343l-10.4 7.601a.79.79 0 0 1-.47.153Z'
							/>
							<path
								fill='#004191'
								d='M15.6 12.133a.701.701 0 0 1-.415-.137L-.415.596A.738.738 0 0 1-.715 0c0-.236.112-.458.3-.595l10.4-7.6a.697.697 0 0 1 .83 0l15.6 11.4c.189.137.3.36.3.596a.738.738 0 0 1-.298.595l-10.401 7.6a.697.697 0 0 1-.416.137Z'
							/>
							<path
								fill='#00408F'
								d='M15.6 12.039a.61.61 0 0 1-.361-.12L-.361.52a.645.645 0 0 1 0-1.038l10.4-7.601a.611.611 0 0 1 .724 0l15.6 11.4a.645.645 0 0 1 0 1.04l-10.4 7.6a.611.611 0 0 1-.363.119Z'
							/>
							<path
								fill='#003F8D'
								d='M15.6 11.945a.523.523 0 0 1-.308-.1L-.308.443A.547.547 0 0 1-.531 0c0-.175.083-.34.223-.443l10.4-7.6a.52.52 0 0 1 .618 0l15.6 11.4c.14.102.223.267.223.443 0 .175-.083.34-.223.443l-10.4 7.6a.52.52 0 0 1-.31.101Z'
							/>
							<path
								fill='#003F8C'
								d='M15.6 11.851a.433.433 0 0 1-.255-.084L-.255.367a.456.456 0 0 1 0-.733l10.4-7.6a.43.43 0 0 1 .511 0l15.601 11.4a.456.456 0 0 1 0 .733l-10.4 7.6a.427.427 0 0 1-.256.084Z'
							/>
							<path
								fill='#003E8A'
								d='M15.6 11.757a.34.34 0 0 1-.202-.066L-.202.29a.36.36 0 0 1 0-.58l10.4-7.602a.345.345 0 0 1 .405 0l15.6 11.4a.36.36 0 0 1 0 .58l-10.4 7.602a.345.345 0 0 1-.203.066Z'
							/>
							<path
								fill='#003D88'
								d='M15.6 11.664a.255.255 0 0 1-.149-.049L-.149.215a.266.266 0 0 1 0-.428l10.4-7.6a.251.251 0 0 1 .298-.001l15.6 11.4a.266.266 0 0 1 0 .428l-10.4 7.6a.251.251 0 0 1-.149.05Z'
							/>
							<path
								fill='#003D86'
								d='M15.6 11.57a.162.162 0 0 1-.095-.031L-.095.139a.17.17 0 0 1 0-.275l10.4-7.6a.16.16 0 0 1 .095-.031c.033 0 .068.011.095.031l15.6 11.4a.169.169 0 0 1 .07.138.169.169 0 0 1-.07.137l-10.4 7.6a.16.16 0 0 1-.095.03Z'
							/>
							<path
								fill='#003C84'
								d='M15.6 11.476a.074.074 0 0 1-.042-.014L-.042.062A.075.075 0 0 1-.072 0c0-.024.01-.047.03-.062l10.4-7.6a.074.074 0 0 1 .042-.013c.015 0 .03.005.042.014l15.6 11.4c.02.014.03.038.03.062a.078.078 0 0 1-.03.061l-10.4 7.6a.074.074 0 0 1-.042.014Z'
							/>
						</g>
					</g>
				</g>
				<path fill='#0CF' fillRule='nonzero' d='M182.401 32.281 172 39.881l15.6 11.4 10.4-7.6z' />
				<path
					fill='#89C947'
					fillRule='nonzero'
					d='M351.541 48.094v-1.408a9.164 9.164 0 0 1-1.565-.15 6.167 6.167 0 0 1-1.231-.37v-1.455c.351.164.784.312 1.299.444.49.129.991.204 1.497.226v-2.564c-.661-.223-1.199-.456-1.613-.697-.41-.242-.711-.522-.903-.841-.191-.323-.287-.71-.287-1.162 0-.465.116-.864.349-1.196.237-.338.565-.604.984-.8a4.127 4.127 0 0 1 1.47-.349v-1.114h.889v1.094c.506.013.973.07 1.401.17.433.096.845.23 1.237.404l-.499 1.271a7.875 7.875 0 0 0-2.139-.513v2.503c.556.182 1.05.378 1.483.588.438.21.779.474 1.025.793.251.314.376.726.376 1.237 0 .67-.246 1.224-.738 1.661-.492.433-1.208.693-2.146.78v1.448h-.889Zm.889-2.768c.437-.055.763-.169.977-.342a.857.857 0 0 0 .322-.69.836.836 0 0 0-.137-.486 1.143 1.143 0 0 0-.417-.355 4.194 4.194 0 0 0-.745-.308v2.181Zm-.889-4.074v-2.14c-.23.019-.457.074-.67.164a.96.96 0 0 0-.41.321.812.812 0 0 0-.137.472c0 .2.041.372.123.513.082.141.212.264.39.369.182.105.417.205.704.3v.001Z'
					opacity='.477'
				/>
				<path
					fill='#89C947'
					fillRule='nonzero'
					d='M270.541 112.094v-1.408a9.166 9.166 0 0 1-1.565-.15 6.214 6.214 0 0 1-1.231-.369v-1.456c.351.164.784.312 1.299.444.49.128.991.204 1.497.226v-2.564c-.661-.223-1.199-.456-1.613-.697-.41-.242-.711-.522-.903-.841-.191-.324-.287-.711-.287-1.162 0-.465.116-.864.349-1.196.237-.338.565-.604.984-.8.424-.196.914-.312 1.47-.349v-1.114h.889v1.094c.506.013.973.07 1.401.171.433.095.845.23 1.237.403l-.499 1.271a7.558 7.558 0 0 0-1.066-.335 7.964 7.964 0 0 0-1.073-.177v2.502c.556.182 1.05.378 1.483.588.438.209.779.474 1.025.793.251.314.376.726.376 1.237 0 .67-.246 1.223-.738 1.661-.492.433-1.208.693-2.146.779v1.449h-.889Zm.889-2.768c.437-.055.763-.169.977-.342a.857.857 0 0 0 .322-.69.838.838 0 0 0-.137-.486 1.145 1.145 0 0 0-.417-.355 4.237 4.237 0 0 0-.745-.308v2.181Zm-.889-4.074v-2.14c-.23.019-.457.074-.67.164a.961.961 0 0 0-.41.321.815.815 0 0 0-.137.472c0 .201.041.372.123.513.082.141.212.264.39.369.182.105.417.205.704.301Z'
					opacity='.493'
				/>
				<path
					fill='#99DB56'
					fillRule='nonzero'
					d='M350.553 103.327v-1.811a11.736 11.736 0 0 1-2.013-.193 7.888 7.888 0 0 1-1.582-.475v-1.872a9.653 9.653 0 0 0 1.67.572c.662.17 1.304.266 1.925.29v-3.296c-.85-.287-1.541-.586-2.074-.897-.528-.31-.915-.671-1.161-1.081-.246-.416-.369-.914-.369-1.494 0-.598.15-1.11.448-1.538.305-.434.727-.776 1.266-1.028.545-.252 1.175-.402 1.89-.449v-1.432h1.142v1.406c.651.018 1.251.09 1.802.22.546.12 1.079.293 1.591.518l-.642 1.635a10.118 10.118 0 0 0-2.751-.659v3.217c.715.234 1.351.486 1.908.756.562.269 1.001.609 1.318 1.019.322.404.483.935.483 1.591 0 .861-.316 1.573-.949 2.136-.633.556-1.553.89-2.76 1.002v1.863h-1.142Zm1.142-3.56c.563-.07.982-.216 1.257-.439a1.1 1.1 0 0 0 .413-.888c0-.246-.058-.454-.176-.624-.111-.17-.29-.322-.536-.457a5.364 5.364 0 0 0-.958-.395v2.803Zm-1.142-5.238v-2.751c-.34.035-.627.106-.862.211a1.23 1.23 0 0 0-.527.413c-.117.17-.176.372-.176.607 0 .257.053.477.158.659.106.181.273.34.501.474.235.135.537.264.906.387Zm-70.965-13.505v-3.017a19.66 19.66 0 0 1-3.355-.323c-1.015-.205-1.894-.468-2.636-.79v-3.12c.752.35 1.679.668 2.783.951a15.2 15.2 0 0 0 3.208.484v-5.493c-1.416-.479-2.568-.977-3.457-1.495-.879-.517-1.524-1.118-1.934-1.801-.41-.694-.615-1.524-.615-2.49 0-.997.249-1.851.747-2.564.508-.723 1.211-1.294 2.109-1.714.909-.42 1.958-.669 3.15-.747v-2.388h1.904v2.344c1.01.02 2.017.143 3.003.366.928.205 1.812.493 2.651.865l-1.069 2.724a16.847 16.847 0 0 0-4.585-1.098v5.36c1.192.392 2.251.811 3.179 1.26.937.45 1.67 1.016 2.197 1.7.537.674.806 1.557.806 2.651 0 1.436-.528 2.622-1.582 3.56-1.055.927-2.588 1.484-4.6 1.67v3.105h-1.904Zm1.904-5.932c.938-.118 1.636-.362 2.095-.733.459-.38.688-.874.688-1.48 0-.41-.097-.756-.293-1.04-.185-.283-.483-.537-.893-.761-.401-.225-.933-.444-1.597-.66v4.674Zm-1.904-8.73v-4.586c-.567.059-1.045.176-1.436.352-.39.175-.683.405-.879.688-.195.283-.293.62-.293 1.01 0 .43.088.797.264 1.1.176.302.454.566.835.79.391.225.894.44 1.509.645v.001Zm5.506-40.221v-3.22a20.95 20.95 0 0 1-3.578-.343c-1.084-.219-2.021-.5-2.813-.844v-3.328c.802.375 1.792.713 2.969 1.016 1.177.302 2.318.474 3.422.515v-5.86c-1.511-.51-2.74-1.04-3.688-1.593-.937-.552-1.625-1.193-2.062-1.922-.438-.74-.656-1.625-.656-2.656 0-1.063.265-1.974.796-2.734.542-.771 1.292-1.38 2.25-1.829.969-.447 2.089-.713 3.36-.796V0h2.031v2.5c1.156.031 2.224.161 3.203.39.99.22 1.932.526 2.828.922l-1.14 2.906a17.04 17.04 0 0 0-2.438-.765 17.96 17.96 0 0 0-2.453-.406v5.718c1.271.417 2.401.865 3.391 1.344 1 .48 1.781 1.084 2.343 1.813.573.718.86 1.661.86 2.828 0 1.531-.563 2.797-1.688 3.797-1.125.99-2.76 1.583-4.906 1.78v3.313h-2.031v.001Zm2.031-6.329c1-.125 1.745-.385 2.234-.781.49-.406.735-.932.735-1.578 0-.438-.104-.807-.313-1.11-.198-.302-.515-.572-.953-.812-.427-.24-.995-.474-1.703-.703v4.984Zm-2.031-9.312V5.61c-.604.062-1.115.187-1.532.374-.416.188-.729.432-.937.735-.208.302-.313.661-.313 1.078 0 .458.094.849.282 1.172.187.322.484.604.89.843.417.24.954.469 1.61.688Z'
				/>
			</g>
		</svg>
	);
};
